import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-cross_sellchoose',
  templateUrl: './cross_sellchoose.dialog.html',
  styleUrls: ['./cross_sellchoose.dialog.scss'],
})
export class Cross_sellchooseDialog implements OnInit {

  constructor(private modalController: ModalController, private alertController: AlertController) { }

  ngOnInit() {}

  dismissModal() {
    this.modalController.dismiss();
  }

  async onClick(event) {
    const alert = await this.alertController.create({
      header: "Do you want to choose \"" + event.name + "\"?",
      subHeader: "Click 'OK' to continue",
      buttons: [
        {
          text: "Cancel",
          role: 'cancel'
        }, {
          text: "Ok",
          handler: ()=>{
            this.modalController.dismiss({name: event.name, id: event.id})
          }
        }
      ]
    });

    await alert.present();
  }
}
